var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"app-qiniu__preview-image",style:({
    'background-image': ("url('" + _vm.src + "')")
  })},[_c('div',{staticClass:"img-box-one",attrs:{"src":_vm.src,"alt":"pdf"}})])}
var staticRenderFns = []

export { render, staticRenderFns }